module.exports = __webpack_public_path__ + "img/buy_super_en.341295fa.png";